import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccessDevelopmentPlans } from '@/hooks/useCanAccessDevelopmentPlans';

/**
 * Blocks access to the leadership Development Plans page when the store has
 * restricted it to Directors. Waits for settings to resolve before deciding
 * so the page never flashes for a restricted user.
 */
export default function DevelopmentPlansGuard({ children }: { children: React.ReactNode }) {
  const { canAccess, isLoading } = useCanAccessDevelopmentPlans();

  if (isLoading) {
    return <div className="p-6 text-center text-gray-400">Loading…</div>;
  }
  if (!canAccess) {
    return <Navigate to="/leadership/dashboard" replace />;
  }
  return <>{children}</>;
}
